export default __webpack_public_path__ + "static/get-to-know-italys-most-famous-beaches-sicily-9eeb00fa3c459b401980c3bf4dd0f91d.jpg";